module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-collector-4.5f4c0520.svg";